import { render, staticRenderFns } from "./UserRoutesEditor.vue?vue&type=template&id=bf18e888&"
import script from "./UserRoutesEditor.vue?vue&type=script&lang=js&"
export * from "./UserRoutesEditor.vue?vue&type=script&lang=js&"
import style0 from "./UserRoutesEditor.vue?vue&type=style&index=0&id=bf18e888&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports